export class Bank {
    id: number;
    name: string;
    type: string;
    currency: string;
    branch_id: number;
    last_updated: string = new Date().toISOString().substr(0, 10);
}


// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/accounting/bank.ts